/**
 * Created with JetBrains WebStorm.
 * User: xuyafeng
 * Date: 15-8-26
 * Time: 上午11:51
 * To change this template use File | Settings | File Templates.
 */
import { urlToObj, objectParseToString} from "./libs/urlObj";
var sdkTool = function () {
    var ua = navigator.userAgent.toLowerCase();
    var br = {
        br:"",
        device:"",
        ver:"",
        params:null,
        os:""
    }

    function urlParams() {
        var url = window.location.search;
        var result = {};
        if (url.indexOf("?") != -1) {
            var str = url.substr(1);
            var strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
                var key = strs[i].substr(0, strs[i].indexOf("="));
                var value = strs[i].substr(strs[i].indexOf("=") + 1);
                result[key] = value;
            }
        }
        return result;
    }

    function getBrowser(ua) {
        var config = [
            {name:"ie", test:/msie/},
            {name:"opera", test:/opera/},
            {name:"firefox", test:/firefox/},
            {name:"safari", test:/safari.*(?!chrome)/},
            {name:"chrome", test:/chrome/},
            {name:"wph", test:/windows phone/},
            {name:"ps", test:/playstation/},
            {name:"uc", test:/ucbrowser|ucweb/},
            {name:"ps", test:/playstation/},
            {name:"xiaomi", test:/xiaomi/},
            {name:"qq", test:/qqbrowser/},
            {name:"weixin", test:/micromessenger/},
            {name:"360", test:/360browser/},
            {name:"baidu", test:/baidu/},
            {name:"qqwebview", test:/ qq/},
            {name:"sougou", test:/sougou/},
            {name:"liebao", test:/liebaofast/},
            {name:"letv", test:/eui browser/}
        ]
        var br = "un";
        for (var i = 0; i < config.length; i++) {
            var item = config[i];
            if (item.test.test(ua)) {
                br = item.name;
            }
        }
        return br;
    }

    function getDevice(ua) {
        var config = [
            {name:"wph", test:/windows phone/},
            {name:"ipad", test:/ipad/},
            {name:"iphone", test:/iphone/},
            {name:"androidPad", test:/(?!.*mobile)android/},
            {name:"androidPhone", test:/android.*mobile/},
            {name:"android", test:/android/},
            {name:"pc", test:/windows/},
            {name:"mac", test:/macintosh|mac os x/}
        ]
        for (var i = 0; i < config.length; i++) {
            var item = config[i];
            if (item.test.test(ua)) {
                return item.name;
            }
        }
        return "un";
    }

    function getVersion(ua) {
        var browser = {};
        var s;
        (s = ua.match(/msie ([\d.]+)/))
            ? browser.msie = s[1]
            : (s = ua.match(/firefox\/([\d.]+)/))
            ? browser.firefox = s[1]
            : (s = ua.match(/360browser/))
                ? browser.b360 = (s[1] ? s[1] : '-')
                : (s = ua.match(/qqbrowser\/([\d.]+)/))
                    ? browser.bqq = s[1]
                    : (s = ua.match(/ucbrowser\/([\d.]+)/))
                        ? browser.buc = s[1]
                        : (s = ua.match(/baidubrowser\/([\d.]+)/))
                            ? browser.bbaidu = s[1]
                            : (s = ua.match(/sogoumobilebrowser\/([\d.]+)/))
                                ? browser.bsgm = s[1]
                                : (s = ua.match(/liebaofast\/([\d.]+)/))
                                    ? browser.blbfast = s[1]
                                    : (s = ua.match(/mb2345browser\/([\d.]+)/))
                                        ? browser.b2345 = s[1]
                                        : (s = ua.match(/4g explorer\/([\d.]+)/))
                                            ? browser.b4g = s[1]
                                            : (s = ua.match(/huohoubrowser\/([\d.]+)/))
                                                ? browser.bhuohou = s[1]
                                                : (s = ua.match(/maxthon[\/ ]([\d.]+)/))
                                                    ? browser.maxthon = s[1]
                                                    : (s = ua.match(/(opera)|(opr)\/([\d.]+)/))
                                                        ? browser.opera = s[3]
                                                        : (s = ua.match(/chrome\/([\d.]+)/))
                                                            ? browser.chrome = s[1]
                                                            : (s = ua.match(/version\/([\d.]+).*safari/))
                                                                ? browser.safari = s[1]
                                                                : browser.other = '-';
        var version = "";
        for (var i in  browser) {
            version = browser[i];
        }
        return version;
    }

    function getOs(ua) {
        if (navigator){
            var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
            var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
            if (isMac) return "mac";
            if (isWin) {
                var isWin2K = ua.indexOf("windows nt 5.0") > -1 || ua.indexOf("windows 2000") > -1;
                if (isWin2K) return "win2000";
                var isWinXP = ua.indexOf("windows nt 5.1") > -1 || ua.indexOf("windows XP") > -1;
                if (isWinXP) return "winXP";
                var isWin2003 = ua.indexOf("windows nt 5.2") > -1 || ua.indexOf("windows 2003") > -1;
                if (isWin2003) return "win2003";
                var isWinVista = ua.indexOf("windows nt 6.0") > -1 || ua.indexOf("windows vista") > -1;
                if (isWinVista) return "winVista";
                var isWin7 = ua.indexOf("windows nt 6.1") > -1 || ua.indexOf("windows 7") > -1;
                if (isWin7) return "win7";
            }
            if (/android/.test(ua)) {
                return "android";
            }
            if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || ua.match(/iphone/) || ua.match(/ipad/)) {
                return "ios";
            }
            var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
            if (isUnix) return "unix";
            var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
            if (isLinux) return "linux";
        }
        return "un";
    }

    return {
        br:br,
        getOs:function () {
            if (br.os == "") {
                br.os = getOs(ua);
            }
            return br.os;
        },
        getUrlParams:function (key) {
            if (br.params == null) br.params = urlParams();
            if (br.params && br.params.hasOwnProperty(key)) {
                return br.params[key];
            }
            return false;
        },
        getDevice:function () {
            if (br.device == "") {
                br.device = getDevice(ua);
            }
            return  br.device;
        },
        getBrowser:function () {
            if (br.br == "") {
                br.br = getBrowser(ua);
            }
            return br.br;
        },
        getBrowserVersion:function () {
            if (br.br == "") {
                br.br = getBrowser(ua);
            }
            if (br.ver == "") {
                br.ver = getVersion(ua);
            }
            return br.br + br.ver;
        },
        now:Date.now || function () {
            return +new Date();
        },
        //创建唯一id
        creatUuid:function () {
            var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
            var uuid = [], i;
            var len = 32, radix = 16;
            radix = radix || chars.length;
            if (len) {
                // Compact form
                for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
            } else {
                // rfc4122, version 4 form
                var r;
                // rfc4122 requires these characters
                uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
                uuid[14] = '4';

                // Fill in random data.  At i==19 set the high bits of clock sequence as
                // per rfc4122, sec. 4.1.5
                for (i = 0; i < 36; i++) {
                    if (!uuid[i]) {
                        r = 0 | Math.random() * 16;
                        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
                    }
                }
            }
            return uuid.join('');
        },
        urlToObj: urlToObj,
        getMate: function () {
            var head = document.head || document.getElementsByTagName('head')[0]
            var metaList = head.getElementsByTagName("meta");
            var meta = {};
            for (var i = 0; i < metaList.length; i++) {
                var item = metaList[i];
                if (item.name != "") {
                    meta[item.name] = item.content;
                }
            }
            return meta;
        },
        objectParseToString: objectParseToString,
        /**
         1. 设置cookie的值，把name变量的值设为value
         example videoSdkTool.cookie(’name’, ‘value’);
         2.新建一个cookie 包括有效期 路径 域名等
         example videoSdkTool.cookie(’name’, ‘value’, {expires: 7, path: ‘/’, domain: ‘jquery.com’, secure: true});
         3.新建cookie
         example videoSdkTool.cookie(’name’, ‘value’);
         4.删除一个cookie
         example videoSdkTool.cookie(’name’, null);
         5.取一个cookie(name)值给myvar
         var account= videoSdkTool.cookie('name');
         **/
        cookie:function (name, value, options) {
            if (typeof value != 'undefined') { // name and value given, set cookie
                options = options || {};
                if (value === null) {
                    value = '';
                    options.expires = -1;
                }
                var expires = '';
                if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
                    var date;
                    if (typeof options.expires == 'number') {
                        date = new Date();
                        date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
                    } else {
                        date = options.expires;
                    }
                    expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
                }
                var path = options.path ? '; path=' + options.path : '';
                var domain = options.domain ? '; domain=' + options.domain : '';
                var secure = options.secure ? '; secure' : '';
                document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
            } else { // only name given, get cookie
                var cookieValue = null;
                if (document.cookie && document.cookie != '') {
                    var cookies = document.cookie.split(';');
                    for (var i = 0; i < cookies.length; i++) {
                        var cookie = cookies[i];
                        if(cookie.substr(0,1)==" ") cookie=cookie.substr(1);
                        // Does this cookie string begin with the name we want?
                        if (cookie.substring(0, name.length + 1) == (name + '=')) {
                            cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                            break;
                        }
                    }
                }
                return cookieValue;
            }
            return null;
        },
        setLocal:function (name, value, cookie) {
            if (typeof cookie == "undefined") {cookie=true;}
            if (window.localStorage) {
                try {
                    //无痕浏览器会报错
                    localStorage.setItem(name, value);
                } catch (e) {
                }
            }
            if(cookie){
                this.cookie(name, value, cookie);
            }
        },
        getLocal:function (name,cookie) {
            if (typeof cookie == "undefined") {cookie=true;}
            if (window.localStorage) {
                try {
                    if (localStorage.getItem(name)) {
                        return localStorage.getItem(name);
                    }
                } catch (e) {
                }
            }
            if(cookie){
                return this.cookie(name);
            }
            return -1;
        },
        num2Time:function (num) {
            var hours;
            var min;
            if (parseInt(num / 60) < 10) {
                hours = "0" + parseInt(num / 60) + ":"
            } else {
                hours = parseInt(num / 60) + ":"
            }
            if (parseInt(num % 60) < 10) {
                min = "0" + parseInt(num % 60) + "";
            } else {
                min = parseInt(num % 60) + "";
            }
            return hours + min;
        },
        lt10:function (time) {
            return time<10?"0"+time:time;
        },
        num2Duration:function (num) {
            if(parseInt(num/60) >= 60){//大于60分钟
                return this.lt10(parseInt(num/3600))+":"+this.lt10(parseInt(num/60%60))+":"+this.lt10(parseInt(num%60));
            }else{
                return this.lt10(parseInt(num/60))+":"+this.lt10(parseInt(num%60));
            }
        },
        clone:function (obj) {
            var o, i, j, k;
            if (typeof(obj) != "object" || obj === null)return obj;
            if (obj instanceof(Array)) {
                o = [];
                i = 0;
                j = obj.length;
                for (; i < j; i++) {
                    if (typeof(obj[i]) == "object" && obj[i] != null) {
                        o[i] = arguments.callee(obj[i]);
                    }
                    else {
                        o[i] = obj[i];
                    }
                }
            }
            else {
                o = {};
                for (i in obj) {
                    if (typeof(obj[i]) == "object" && obj[i] != null) {
                        o[i] = arguments.callee(obj[i]);
                    }
                    else {
                        o[i] = obj[i];
                    }
                }
            }
            return o;
        },
        isHttps:function () {
            try {
                return window.location.protocol == "https:";
            } catch (e) {
            }
            return false;
        },
        isArray:function (o) {
            return Object.prototype.toString.call(o) === '[object Array]';
        },
        isFunction:function(fn) {
            return Object.prototype.toString.call(fn)=== '[object Function]';
        },
        isIe6: function() {
            return /msie 6/.test(navigator.userAgent.toLowerCase());
        },
        isNullObj: function(obj) {
            if(typeof obj =="object"){
                for(var key in obj){
                    return false
                }
                return true;
            }
            return false
        },
        isMobile: function() {
            if ((navigator.userAgent.match(/(phone|pad|pod|ios|android|mobile|blackberry|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian)/i))) {
                return true;
            }
            return false;
        },
        //获得数组中随机一项
        getRndItemFromArr:function (arr) {
            if(this.isArray(arr)){
                return arr[Math.floor(Math.random()*arr.length)];
            }
            return arr;
        }
    }

}();
export default sdkTool;
